import React from 'react';
import { Badge } from '../ui/badge';
import { useTranslation } from '../../hooks/useTranslation';

const PRIORITY_STYLES = {
  high: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  medium: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  low: 'bg-sky-500/10 text-sky-400 border-sky-500/30',
  discard: 'bg-red-500/10 text-red-400 border-red-500/30',
  unknown: 'bg-zinc-800 text-zinc-400 border-zinc-700',
};

export function PriorityBadge({ priority }) {
  const { t } = useTranslation();
  const key = PRIORITY_STYLES[priority] ? priority : 'unknown';

  return (
    <Badge variant="outline" className={PRIORITY_STYLES[key]}>
      {t(`aiLeadScanner.priority.${key}`)}
    </Badge>
  );
}
